export default __webpack_public_path__ + "./images/ge.2ebb53f0.png";